import { Directive } from '@angular/core';

@Directive({
  selector: 'xpo-tray-panel-content',
})
export class XpoTrayPanelContentDirective {}
